import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CmsConfig, ConfigModule, DeferLoadingStrategy } from '@spartacus/core';
import { GenericLinkModule, MediaModule } from '@spartacus/storefront';
import { WarrantyComponent } from './warranty.component';

@NgModule({
  declarations: [WarrantyComponent],
  imports: [
    CommonModule,
    GenericLinkModule,
    MatIconModule,
    MediaModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ShimanoDownloadMediaComponent: {
          component: WarrantyComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    } as CmsConfig),
  ],
})
export class WarrantyModule {}
